// removed by extract-text-webpack-plugin
module.exports = {"buttonRightIcon":"G89a9e1 Gb69063 G4339af"};